import Drawer from '@material-ui/core/Drawer';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Icon from '../../../../atoms/Icon';

function headerDefault(title, iconClose, onClose, rightSection, onShowClose) {
  return (
    <>
      {(title || onShowClose || rightSection) && (
        <div className="menu-aside__header">
          <div className="menu-aside__header-title">{title}</div>
          <div className="menu-aside__header-right">
            {rightSection}
            {onShowClose && (
              <div className="menu-aside__icon-close" onClick={onClose}>
                <Icon type="close" size="big" />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

const MenuAside = ({
  open = false,
  items,
  itemActive,
  onClick,
  t,
  withCover,
  iconClose,
  title,
  footer,
  onClose,
  rightSection,
  position,
  children,
  width,
  closeOutAside,
  className,
  onShowClose,
  header = headerDefault(title, iconClose, onClose, rightSection, onShowClose),
}) => {
  return (
    <>
      <Drawer anchor={position} open={open} onClose={onClose} className={`${className} menu-aside--position-${position}`}>
        <div
          className={`menu-aside ${open ? ' menu-aside--active' : ''} `}
          style={{ width: width, transform: !open ? `translateX(${position === 'left' ? `-${width}px` : `${width}px`})` : null }}
        >
          {header}
          <div id="menu-aside__content" className="menu-aside__content">
            {children && <div className="menu-aside__children">{children}</div>}
          </div>

          {footer && <div className="menu-aside__footer">{footer}</div>}
        </div>
      </Drawer>
      {withCover && open && <div className="menu-aside__cover"></div>}
    </>
  );
};

MenuAside.propTypes = {
  open: PropTypes.bool,
  items: PropTypes.array,
  itemActive: PropTypes.string,
  onClick: PropTypes.func,
  withCover: PropTypes.bool,
  iconClose: PropTypes.object,
  title: PropTypes.string,
  footer: PropTypes.object,
  header: PropTypes.object,
  position: PropTypes.oneOf(['right', 'left']),
  width: PropTypes.number,
  onClose: PropTypes.func,
  closeOutAside: PropTypes.bool,
  onShowClose: PropTypes.bool,
};

MenuAside.defaultProps = {
  position: 'left',
  width: 358,
  closeOutAside: true,
  onShowClose: true,
};

export default withTranslation([])(MenuAside);
